import { connect } from 'react-redux';
import AggregateContainer from '../../components/event/AggregateContainer';
import { getEventAggregationType, getEventSplitColumn } from '../../reducers/analyticsApp';
import { setEventAggregationType } from '../../actions/events/csvEvents';

const mapStateToProps = (state, { id }) => ({
  aggregationType: getEventAggregationType(state, id),
  splitColumn: getEventSplitColumn(state, id),
});

const mapDispatchToProps = (dispatch, { id }) => ({
  onChangeAggregationType: (v) => dispatch(setEventAggregationType(id, v)),
});

const AggregationContainer = connect(mapStateToProps, mapDispatchToProps)(AggregateContainer);

export default AggregationContainer;
